<script lang="ts">
	import { page } from '$app/stores';
	import type { Language } from '$lib/i18n';
	import HeroSection from './_components/HeroSection.svelte';
	import SocialProof from './_components/SocialProof.svelte';
	import ServicesSection from './_components/ServicesSection.svelte';
	import AnalyticsPlatformSection from './_components/AnalyticsPlatformSection.svelte';
	import ContactSection from './_components/ContactSection.svelte';
	import FinalCTASection from './_components/FinalCTASection.svelte';

	let lang = $derived($page.params.lang as Language);
</script>

<HeroSection {lang} />
<SocialProof {lang} />
<ServicesSection {lang} />
<AnalyticsPlatformSection {lang} />
<ContactSection {lang} />
<FinalCTASection {lang} />
